import Cookies from 'js-cookie';

const TokenKey = 'Admin-token';
const RefreshTokenKey = 'refresh-token';

export function getToken() {
    return Cookies.get(TokenKey);
}

export function getRefreshToken() {
    return Cookies.get(RefreshTokenKey);
}

export function setToken(token) {
    return Cookies.set(TokenKey, token);
}

export function setRefreshToken(token) {
    return Cookies.set(RefreshTokenKey, token);
}

export function removeToken() {
    Cookies.remove('saber-access-token');
    Cookies.remove('saber-refresh-token');
    Cookies.remove(RefreshTokenKey);
    return Cookies.remove(TokenKey);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js